import { render, staticRenderFns } from "./profiles.vue?vue&type=template&id=67347e1b&scoped=true"
import script from "./profiles.vue?vue&type=script&lang=js"
export * from "./profiles.vue?vue&type=script&lang=js"
import style0 from "./profiles.vue?vue&type=style&index=0&id=67347e1b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67347e1b",
  null
  
)

export default component.exports